var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_200)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.625 7.49995C15.6276 8.70522 15.2404 9.87902 14.5213 10.8462L10 16.875L5.47875 10.8462C4.94938 10.131 4.59724 9.30042 4.45124 8.42268C4.30524 7.54494 4.36955 6.64508 4.63889 5.79703C4.90824 4.94898 5.37492 4.17692 6.00062 3.54427C6.62632 2.91162 7.39318 2.43644 8.23821 2.15774C9.08324 1.87905 9.98232 1.80481 10.8616 1.9411C11.7409 2.0774 12.5753 2.42035 13.2963 2.94179C14.0173 3.46323 14.6044 4.14827 15.0092 4.94065C15.414 5.73304 15.625 6.61015 15.625 7.49995ZM17.5 7.49995C17.5 9.17495 16.9513 10.72 16.025 11.9675L11.1713 18.4375L10 20L8.8275 18.4375L3.975 11.9675C3.26836 11.0142 2.79797 9.90695 2.60248 8.73658C2.407 7.56622 2.49199 6.36617 2.85049 5.23505C3.20898 4.10392 3.83074 3.07399 4.66468 2.22989C5.49863 1.38578 6.52095 0.751595 7.64765 0.379429C8.77436 0.00726265 9.97329 -0.0922599 11.1459 0.0890384C12.3186 0.270337 13.4315 0.727282 14.3932 1.42233C15.3549 2.11738 16.138 3.03069 16.678 4.08723C17.2181 5.14376 17.4998 6.31337 17.5 7.49995ZM10 9.99995C10.663 9.99995 11.2989 9.73656 11.7678 9.26772C12.2366 8.79888 12.5 8.16299 12.5 7.49995C12.5 6.83691 12.2366 6.20102 11.7678 5.73218C11.2989 5.26334 10.663 4.99995 10 4.99995C9.33696 4.99995 8.70107 5.26334 8.23223 5.73218C7.76339 6.20102 7.5 6.83691 7.5 7.49995C7.5 8.16299 7.76339 8.79888 8.23223 9.26772C8.70107 9.73656 9.33696 9.99995 10 9.99995Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAddress);
export default __webpack_public_path__ + "static/media/MyAddress.cedc711cd36015d0540ecd7c71d790a7.svg";
export { ForwardRef as ReactComponent };